<div
  [class.twitter-public-context]="isTwitterPublicContext"
  [class]="'avatar-and-bubble message-type-' + message.type"
  [ngClass]="{
    'public-context-not-from-brand': isPublicContextModal && !message['isFromBrand'],
    'task-with-shop-product': !!message['shopProductInfo']
  }">
  <app-avatar
    *ngIf="isPublicContextModal"
    [src]="message['from']?.avatarURL"
    [isCompany]="message['isFromBrand'] || (message.type && message.type !== 'task')"
    class="avatar-thumbnail"></app-avatar>

  <div *ngIf="isTaskProcessPageMessageList" class="avatar-or-spacer">
    <app-avatar
      *ngIf="avatarUrl"
      [src]="avatarUrl"
      [isCompany]="message['isFromBrand'] || message.type !== 'task'"
      class="avatar-thumbnail"></app-avatar>
    <div *ngIf="!avatarUrl" class="avatar-spacer"></div>
  </div>
  <!-- delete button -->
  <div class="buttons-before-bubble-container" *ngIf="!isUserReadOnly">
    <ion-button
      *ngIf="hasDeleteAnswerMessageModalButton(message)"
      (click)="onDeleteAnswerMessageClicked(message)"
      [matTooltip]="'delete' | translate"
      class="icon-button-before-bubble"
      fill="clear">
      <ion-icon slot="icon-only" name="trash" color="danger"></ion-icon>
    </ion-button>
  </div>
  <div [id]="taskProcessService.bubbleElementId(message.id)" [ngClass]="bubbleCssClasses">
    <div *ngIf="isPublicContextModal" class="sender-name">
      {{ message['from']?.name }}
    </div>
    <ng-container *ngIf="!message['isAnonymized']">
      <ng-container [ngSwitch]="message.type">
        <app-message-whatsapp-template *ngSwitchCase="TaskOrActionType.WhatsappTemplate" [message]="$any(message)">
        </app-message-whatsapp-template>

        <app-message-kakaotalk-template *ngSwitchCase="TaskOrActionType.KakaotalkTemplate" [message]="$any(message)">
        </app-message-kakaotalk-template>

        <app-message-inmessage-carousel *ngSwitchCase="TaskOrActionType.InmessageCarousel" [carousel]="$any(message)">
        </app-message-inmessage-carousel>

        <ng-container *ngSwitchDefault>
          <app-message-text-content
            [content]="message.content?.text"
            [site]="$any(taskProcessContext.site)"
            [isPrivate]="!isPublic"
            [ngClass]="{ 'line-through': message['isDeleted'] }"></app-message-text-content>
          <div class="bubble-attachments-row">
            <app-attachment-thumbnail
              *ngFor="let attachment of message.content?.attachments"
              [attachment]="attachment"></app-attachment-thumbnail>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <span *ngIf="message['isAnonymized']" [ngClass]="{ 'line-through': message['isDeleted'] }" class="anonymized">
      {{ 'm/task-process/anonymized-message-placeholder' | translate }}
    </span>
    <div class="message-status-and-timestamp-row">
      <div class="message-status-and-error-buttons">
        <div class="message-status">
          <div class="message-status-blue-part">{{ messageStatusBluePart }}</div>
          <div class="message-status-grey-part alc-ellipsis">{{ messageStatusGreyPart }}</div>
          <div *ngIf="shouldShowScrollConversation()" class="scroll-conversation">
            <ion-button (click)="scrollConversationConfig.onClickFn()" fill="clear">
              {{ scrollConversationConfig.labelKey | translate }}
            </ion-button>
          </div>
        </div>
        <span class="rating-stars">
          <ng-container *ngIf="filledStars.length > 0">
            <ion-icon *ngFor="let star of filledStars" name="star"></ion-icon>
          </ng-container>
          <ng-container *ngIf="emptyStars.length > 0">
            <ion-icon *ngFor="let star of emptyStars" name="star-outline"></ion-icon>
          </ng-container>
        </span>
        <div *ngIf="hasActionError() && !isUserReadOnly" class="error-buttons">
          <ion-button (click)="showActionError()" fill="clear">
            {{ 'm/task-process/bubble/see-error' | translate }}
          </ion-button>
          <ion-button
            *ngIf="isTaskProcessPageMessageList && $any(message).error?.logAnswerRequest"
            (click)="onRetryClicked()"
            fill="clear">
            {{ 'm/task-process/bubble/retry' | translate }}
          </ion-button>
        </div>
      </div>
      <ng-container *ngIf="message['externalUrl']; else messageTime">
        <a [href]="message['externalUrl']" target="_blank">
          <ng-container *ngTemplateOutlet="messageTime"></ng-container>
        </a>
      </ng-container>
    </div>
  </div>
  <!-- end message-bubble -->
  <div class="buttons-after-bubble-container" [class.hidden]="$any(message).closed">
    <ion-button
      *ngIf="hasTaskActionModalButton(message)"
      (click)="copyTaskUrl(message)"
      [matTooltip]="'m/task-process/tooltips/copy-link' | translate"
      class="icon-button-after-bubble"
      fill="clear">
      <ion-icon slot="icon-only" src="assets/img/link.svg"></ion-icon>
    </ion-button>
    <ion-button
      *ngIf="hasTaskActionModalButton(message)"
      (click)="showTaskActionsModal(message)"
      [matTooltip]="'m/task-process/tooltips/actions-log' | translate"
      class="icon-button-after-bubble"
      fill="clear">
      <ion-icon slot="icon-only" src="assets/img/history.svg"></ion-icon>
    </ion-button>
    <ion-button
      *ngIf="hasPublicContextModalButton(message)"
      (click)="showPublicContextModal(message)"
      [matTooltip]="'m/task-process/tooltips/public-context' | translate"
      class="icon-button-after-bubble"
      fill="clear">
      <ion-icon slot="icon-only" src="assets/img/globe.svg"></ion-icon>
    </ion-button>
  </div>
</div>
<div class="quoted-tweet-container">
  <div class="avatar-or-spacer avatar-spacer"></div>
  <ngx-tweet *ngIf="message['quotedMessageExternalId']" [tweetId]="message['quotedMessageExternalId']"></ngx-tweet>
</div>
<div *ngIf="isPreviousOnHoldNotByBotIds" class="ignore-or-archive-container">
  <ion-button (click)="taskProcessContext.scrollToProcessedTask()" color="warning">
    <ion-icon name="chevron-down" slot="start"></ion-icon>
    {{ 'm/task-process/previous-on-hold/leave-it' | translate }}
  </ion-button>
  {{ 'm/task-process/previous-on-hold/or' | translate }}
  <ion-button (click)="archiveAndScrollBackToProcessedMessage()" color="light">
    <ion-icon name="archive" slot="start"></ion-icon>
    {{ 'm/task-process/previous-on-hold/archive-it' | translate }}
  </ion-button>
</div>

<ng-template #messageTime>
  <div class="message-time-container">
    <span [matTooltip]="message.datetime | dateTimezone: 'medium'">
      <span *ngIf="!message['timeDelta']">
        {{ message.datetime | dateTimezone: 'shortTime' }}
      </span>
      <span *ngIf="message['timeDelta'] as delta" [appValueAndUnit]="delta" class="alc-text-nowrap"></span>
    </span>
  </div>
</ng-template>
